import React from 'react';
import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import moment from 'moment';
import { Table, Row, Col, Breadcrumb, Typography, Tooltip } from 'antd';
import { FormOutlined, EyeOutlined } from '@ant-design/icons';
import { intialPaginationState, showingPageTotalRange, filter, unexpectedError } from '../../common_functions';
const Artist = props => {
  const [artists, setArtists] = useState([]);
  const [pagination, setPagination] = useState(intialPaginationState);
  const [sorter, setSorter] = useState(null);
  const [loading, setLoading] = useState(false);
  const columns = [
    {
      title: 'Sr. No.',
      dataIndex: 'id',
      key: 'id',
      render: (value, item, index) => {
        return (pagination.current - 1) * pagination.pageSize + index + 1;
      },
    },
    {
      title: 'First Name',
      dataIndex: 'First_Name',
      key: 'First_Name',
      sorter: true,
      ...filter('First_name'),
      render: (text, record) => <span style={{ textTransform: 'capitalize' }}>{text}</span>,
    },
    {
      title: 'Last Name',
      dataIndex: 'last_name',
      key: 'last_name',
      sorter: true,
      ...filter('last_name'),
      render: (text, record) => <span style={{ textTransform: 'capitalize' }}>{text}</span>,
    },
    {
      title: 'Cona Code',
      dataIndex: 'cona_code',
      key: 'cona_code',
      sorter: true,
      ...filter('cona_code'),
    },
    {
      title: 'DOB',
      dataIndex: 'dob',
      key: 'dob',
      sorter: true,
      ...filter('dob'),
      render: (text, record) => <span>{moment(text).format('YYYY')}</span>,
    },
    {
      title: 'DOD',
      dataIndex: 'dod',
      key: 'dod',
      sorter: true,
      ...filter('dod'),
      render: (text, record) => (text ? <span>{moment(text).format('YYYY')}</span> : ''),
    },

    {
      title: 'Actions',
      key: 'action',
      render: (text, record) => (
        <span>
          <div className="actionbtngroup">
            <Link to={'/artists/edit/' + record.id}>
              <Tooltip placement="top" title={props.roleType === 'admin' || props?.tabs_permissions?.artists?.edit ? 'Edit' : 'View'}>
                <button className="edit-btn">
                  {props.roleType === 'admin' || props?.tabs_permissions?.artists?.edit ? <FormOutlined /> : <EyeOutlined />}
                </button>
              </Tooltip>
            </Link>
            {props.deleteRecord(props, record.id, 'Artist', 'Artist?', artists, setArtists, props?.tabs_permissions?.artists?.delete)}
          </div>
        </span>
      ),
    },
  ];
  useEffect(() => {
    (async () => {
    await getArtists(pagination);
  })();
  }, []);
  const getArtists = async (pagination, filters = {}, sorter = '') => {
    try {
      setLoading(true);
      const response = await props.getItems('Artist', {
        fields: ['id', 'First_Name', 'last_name', 'dob', 'dod', 'cona_code'],
        sort: !!sorter && sorter.field ? (sorter.order === 'ascend' ? '' : '-') + sorter.field : '-id',
        filters: filters,
        offset: pagination.pageSize * (pagination.current - 1),
        limit: pagination.pageSize,
        meta: 'filter_count',
      });
      pagination.total = response.meta.filter_count;
      setPagination(pagination);
      setArtists(response.data);
    } catch (error) {
      unexpectedError(error);
    } finally {
      setLoading(false);
    }
  };
  let handleTableChange = async (pagination, filters, sorter) => {
    setPagination(pagination);
    setSorter(sorter);
    setLoading(true);
    let filtersitems = {};
    for (let key in filters) {
      if (filters.hasOwnProperty(key)) {
        let val = filters[key];
        if (val) {
          if (key === 'id') {
            filtersitems[key] = { _eq: val[0] };
          } else if (key === 'dob' || key === 'dod') {
            filtersitems[key] = { _between: val };
          } else {
            filtersitems[key] = { _icontains: val[0] };
          }
        }
      }
    }

    await getArtists(pagination, filtersitems, sorter);
  };

  return (
    <Row>
      <Col span={24} className="app-breadcrumb-col">
        <Breadcrumb items={[{ title: "Artists" }]} />
      </Col>
      <Col className="white-paper" span={24}>
        <div className="dashboard">
          <Row gutter={24} className="page-header-section" align="middle">
            <Col xs={12}>
              <Typography.Title level={4} style={{ margin: 0 }}>
                Artists List
              </Typography.Title>
            </Col>
            <Col xs={12} justify="end">
              {props.createButton(props.roleType, props.tabs_permissions.artists, '/artists/new', 'Create Artist')}
            </Col>
          </Row>
          <hr />
          <div className="artist-list">
            <Table
              scroll={{ x: 'max-content' }}
              columns={columns}
              bordered
              rowKey={record => record.id}
              dataSource={artists}
              pagination={{ ...pagination, ...showingPageTotalRange }}
              loading={loading}
              onChange={handleTableChange}
            />
          </div>
        </div>
      </Col>
    </Row>
  );
};

export default Artist;
